import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { DefaultLayoutComponent } from './containers';
import { AuthGuardService } from './core/guards/auth-guard.service';
import { NotAuthGuardService } from './core/guards/auth-guard.service';
import { ErrorComponent } from './views/error/error.component';
import { PaymentRedirectionComponent } from './views/payment-redirection/payment-redirection.component';

const routes: Routes = [
  { 
    path: 'users',
    redirectTo: '',
    pathMatch: 'full', 

  },

  {
    path: 'redirect-url-paychangu', 
    component: PaymentRedirectionComponent,
    data: {
      title: 'Payment rediretcion' 
    },

  },
  

  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
    {
        path: '',
        loadChildren: () => import('./views/index/index.module').then(m => m.IndexModule),
        canActivate: [NotAuthGuardService]
    },
    {
        path: 'index',
        redirectTo: '',
        pathMatch: 'full'
    },
    {
        path: 'users',
        loadChildren: () => import('./views/users/users.module').then(m => m.UsersModule),
        
    }, 
    {
      path: 'home',
      loadChildren: () => import('./views/home/home.module').then(m => m.HomeModule),
      
    },
    {
      path: 'sell-items',
      loadChildren: () => import('./views/sell-items/sell-items.module').then(m => m.SellItemsModule),
      //canActivate: [AuthGuardService]
      
    },
    {
      path: 'services',
      loadChildren: () => import('./views/services/services.module').then(m => m.ServicesModule),
      
    },
    {
      path: '',
      loadChildren: () => import('./views/show-all-list/show-all-list.module').then(m => m.ShowAllListModule),
      
    },
    {
      path: 'favourite',
      loadChildren: () => import('./views/favourite/favourite.module').then(m => m.FavouriteModule),
      
    },
    {
      path: 'details',
      loadChildren: () => import('./views/details/details.module').then(m => m.DetailsModule),
      
    },
    {
      path: 'dealers',
      loadChildren: () => import('./views/dealers/dealers.module').then(m => m.DealersModule),
    },
    {
      path: 'blog',
      loadChildren: () => import('./views/blog/blog.module').then(m => m.BlogModule),
    },

    ]
},

    {path: '404', component: ErrorComponent},
    {path: '**',pathMatch: 'full', redirectTo: '/404'},
    {path: '****',pathMatch: 'full', redirectTo: '/404'},

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules  ,   
  scrollPositionRestoration: 'enabled',
  onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
